export default "__VITE_ASSET__c766d338__"